import Rest from '../Rest'
import _ from 'lodash'

export default class NewsletterService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/newsletters'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  clone(id: number) {
    return this.post(`${id}/clone`)
  }

  getNewsletterByLink(link: String) {
    return this.get(`/pub/${link}`)
  }

  saveComment(link: String, data: any){
    return this.post(`/pub/${link}/comments`, data)
  }

  likeContent(link: String){
    return this.post(`/pub/${link}/like`)
  }

  loadCommentsByNewsletter(id: Number) {
    return this.get(`/${id}/comments`)
  }

  handlingComment(id: Number, commentId: Number, data : any){
    return this.put(`/${id}/comments/${commentId}/handling`, data)
  }

  cloneByGroup(id: Number, data: any = null) {
    return this.post(`/${id}/clone_by_group`, data)
  }
  cloneBySubgroup(id: Number, data: any = null) {
    return this.post(`/${id}/clone_by_subgroup`, data)
  }

  addSignature(link: String, data: any = null) {
    return this.post(`/pub/${link}/sign`, data)
  }
  getSignatures(id: Number) {
    return this.get(`/${id}/signatures`)
  }

  generateReportSignatures(id: Number, title = 'Relatório de assinaturas') {
    const fileName = _.kebabCase(title)
    return this.download(`/${id}/signatures/generate_report`, fileName, 'application/pdf')
  }
}
